import { useEditorStore } from '../store/editor-store';
import type { CatalogProvider, PrintMethod, ProductModel } from '@ox/schema';

/**
 * DTG / DTF switcher when several models cover the same products.
 */
export function PrintMethodOptions({ catalog }: { catalog: CatalogProvider }) {
  const model = useEditorStore((s) => s.model);
  const changeModel = useEditorStore((s) => s.changeModel);
  const colorKey = useEditorStore((s) => s.document.selection.colorKey);
  const choices = model?.printMethodChoices ?? [];

  if (!model || choices.length <= 1) return null;

  const current = (model.printMethod || 'dtg') as PrintMethod;

  return (
    <div className="ox-print-service-opts ox-print-method-opts">
      <p className="ox-print-service-opts__title">Método de impresión</p>
      <div className="ox-print-service-opts__choices">
        {choices.map((c) => {
          const on = current === c.method;
          return (
            <label
              key={c.method}
              className={`ox-print-service-opts__opt${on ? ' is-on' : ''}`}
              // Inline so storefront themes cannot override the selected state.
              style={
                on
                  ? {
                      borderColor: 'var(--ox-red, #e11d48)',
                      boxShadow: 'inset 0 0 0 1px var(--ox-red, #e11d48)',
                      background: '#fff5f5',
                    }
                  : undefined
              }
            >
              <input
                type="radio"
                name="ox-print-method"
                checked={on}
                onChange={() => {
                  if (c.modelId === model.id) return;
                  void catalog.getModel(c.modelId).then((full: ProductModel) => {
                    changeModel(full, colorKey);
                  });
                }}
              />
              <span>{c.label}</span>
              <span className="ox-print-service-opts__check" aria-hidden>
                {on ? '✓' : ''}
              </span>
            </label>
          );
        })}
      </div>
      {model.askPrintMethod ? (
        <p className="ox-print-service-opts__hint">Elige DTG o DTF para calcular el precio.</p>
      ) : null}
    </div>
  );
}
